<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Header -->
    <div class="bg-white border-b border-gray-200 shadow-sm">
      <div class=" mx-auto py-6 px-4 sm:px-6 lg:px-8" style="max-width: 1400px; margin: 0 auto;">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-4">
            <div
              class="w-12 h-12 bg-gradient-to-r from-red-500 to-red-600 rounded-xl flex items-center justify-center shadow-lg"
            >
              <svg
                class="w-7 h-7 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1m4 0h1m-6 4h8m-7-9h6a2 2 0 012 2v8a2 2 0 01-2 2H8a2 2 0 01-2-2V7a2 2 0 012-2z"
                ></path>
              </svg>
            </div>
            <div>
              <h1 class="text-2xl font-bold text-gray-900">
                Video Tutorials
              </h1>
              <p class="text-gray-600">
                Leer hoe je de UP-TO-DATE AI App gebruikt
              </p>
            </div>
          </div>
          <div class="flex items-center space-x-2 text-sm text-gray-500">
            <svg
              class="w-8 h-8"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1m4 0h1m-6 4h8m-7-9h6a2 2 0 012 2v8a2 2 0 01-2 2H8a2 2 0 01-2-2V7a2 2 0 012-2z"
              ></path>
            </svg>
            <span>{{ tutorials.length }} tutorials beschikbaar</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="x-auto py-4 px-2 sm:py-6 sm:px-4 md:py-8 md:px-6 lg:px-8" style="max-width: 1400px; margin: 0 auto;">
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
        <!-- Video Player Section -->
        <div class="lg:col-span-2 space-y-4 md:space-y-6">
          <!-- Current Video -->
          <div
            v-if="currentVideo"
            class="bg-white rounded-2xl shadow-lg overflow-hidden"
          >
            <div
              class="aspect-w-16 aspect-h-9 bg-gray-900 relative overflow-hidden"
              style="padding-bottom: 56.25%"
            >
              <iframe
                :src="getEmbedUrl(currentVideo.url)"
                width="100%"
                height="100%"
                allow="autoplay"
                frameborder="0" allowfullscreen
                class="w-full h-full absolute top-0 left-0 border-0"
                style="border: none;"
                            ></iframe>
            </div>

            <!-- Video Details -->
            <div class="p-4 md:p-6 lg:p-8">
              <h2 class="text-lg md:text-xl lg:text-2xl font-bold text-gray-900 mb-3 md:mb-4 break-words">
                {{ currentVideo.title }}
              </h2>
              <div class="flex items-center justify-between flex-wrap gap-2 md:gap-4">
                <div
                  class="flex items-center space-x-6 text-base text-gray-600"
                >
                  <div class="flex items-center space-x-2">
                    <svg
                      class="w-8 h-8"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      ></path>
                    </svg>
            <span>Tutorial {{ currentVideo.id }}</span>
                  </div>
                  <div class="flex items-center space-x-2">
                    <svg
                      class="w-8 h-8"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M7 7h.01M7 3h5c1.1 0 2 .9 2 2v1M9 7h1m-4 4h.01M9 11h1m-4 4h.01M9 15h1m-4 4h.01M9 19h1M3 7h3m0 0v10c0 1.1.9 2 2 2h8a2 2 0 002-2V9a2 2 0 00-2-2h-3"
                      ></path>
                    </svg>
                    <span>{{ currentVideo.category }}</span>
                  </div>
                </div>
                <div class="flex items-center space-x-3">
                  <button
                    @click="refreshVideo"
                    class="inline-flex items-center px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm font-medium"
                  >
                    <svg
                      class="w-8 h-8 mr-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                      ></path>
                    </svg>
                    Vernieuwen
                  </button>
                  <a
                    :href="currentVideo.url"
                    target="_blank"
                    class="inline-flex items-center px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium"
                  >
                    <svg
                      class="w-8 h-8 mr-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                      ></path>
                    </svg>
                    Openen in Drive
                  </a>
                </div>
              </div>

              <!-- Video Loading Hint -->
              <div
                class="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg"
              >
                <div class="flex items-start space-x-3">
                  <svg
                    class="w-8 h-8 text-blue-600 mt-0.5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>
                  <div>
                    <p class="text-blue-800 text-sm font-medium">
                      Video Tips:
                    </p>
                    <ul class="text-blue-700 text-sm mt-1 space-y-1">
                      <li>
                        Als de video niet laadt, klik op "Vernieuwen" of "Openen
                        in Drive"
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Navigation Controls -->
          <div class="bg-white rounded-xl shadow-sm p-3 md:p-4">
            <div class="flex items-center justify-between flex-wrap gap-2">
              <button
                @click="previousVideo"
                :disabled="currentIndex === 0"
                class="flex items-center space-x-1 md:space-x-2 px-3 md:px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm"
              >
                <svg
                  class="w-8 h-8 md:w-5 md:h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M15 19l-7-7 7-7"
                  ></path>
                </svg>
                <span class="hidden sm:inline">Vorige</span>
              </button>

              <div class="text-center">
                <p class="text-sm text-gray-600">
                  Video {{ currentIndex + 1 }} van {{ tutorials.length }}
                </p>
              </div>

              <button
                @click="nextVideo"
                :disabled="currentIndex === tutorials.length - 1"
                class="flex items-center space-x-1 md:space-x-2 px-3 md:px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm"
              >
                <span class="hidden sm:inline">Volgende</span>
                <svg
                  class="w-8 h-8 md:w-5 md:h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5l7 7-7 7"
                  ></path>
                </svg>
              </button>
            </div>
          </div>

        </div>

        <!-- Sidebar with Toggle and Content -->
        <div class="space-y-4 md:space-y-6 overflow-hidden">
          <!-- Layout Toggle and Tab Navigation -->
          <div class="bg-white rounded-xl shadow-sm">
            <!-- Toggle Switch -->
            <div class="flex items-center justify-between p-3 border-b border-gray-100">
              <div class="flex items-center space-x-2">
                <svg class="w-8 h-8 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4"></path>
                </svg>
                <span class="text-sm font-medium text-gray-700">Weergave</span>
              </div>
              <div class="flex items-center space-x-3">
                <span class="text-xs text-gray-500">Tabbladen</span>
                <button
                  @click="toggleLayoutMode"
                  :class="[
                    'relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2',
                    layoutMode === 'stacked' ? 'bg-red-600' : 'bg-gray-200'
                  ]"
                >
                  <span
                    :class="[
                      'inline-block h-4 w-4 transform rounded-full bg-white transition-transform',
                      layoutMode === 'stacked' ? 'translate-x-6' : 'translate-x-1'
                    ]"
                  ></span>
                </button>
                <span class="text-xs text-gray-500">Stapel</span>
              </div>
            </div>

            <!-- Tab Navigation (only shown in tabs mode) -->
            <div v-if="layoutMode === 'tabs'" class="flex border-b border-gray-200">
              <button
                @click="activeTab = 'playlist'"
                :class="[
                  'flex-1 px-4 py-3 text-sm font-medium text-center border-b-2 transition-colors',
                  activeTab === 'playlist'
                    ? 'border-red-600 text-red-600 bg-red-50'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                ]"
              >
                <div class="flex items-center justify-center space-x-2">
                  <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                  </svg>
                  <span>Playlist</span>
                </div>
              </button>
              <button
                @click="activeTab = 'instructions'"
                :class="[
                  'flex-1 px-4 py-3 text-sm font-medium text-center border-b-2 transition-colors',
                  activeTab === 'instructions'
                    ? 'border-red-600 text-red-600 bg-red-50'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                ]"
              >
                <div class="flex items-center justify-center space-x-2">
                  <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
                  </svg>

                </div>
              </button>
            </div>
          </div>

          <!-- Content Areas -->
          <!-- TABS MODE: Show only active tab -->
          <div v-if="layoutMode === 'tabs'" class="bg-white rounded-xl shadow-sm">
            <!-- Playlist Tab -->
            <div v-if="activeTab === 'playlist'" class="p-4 md:p-6">
              <div class="flex items-center space-x-3 mb-4">
                <div
                  class="w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center"
                >
                  <svg
                    class="w-8 h-8 text-red-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    ></path>
                  </svg>
                </div>
                <div>
                  <h3 class="font-semibold text-gray-900">Tutorial Afspeellijst</h3>
                  <p class="text-sm text-gray-600">UP-TO-DATE AI App Gids</p>
                </div>
              </div>

              <!-- Search Bar -->
              <div class="mb-4">
                <div class="relative">
                  <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg class="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                    </svg>
                  </div>
                  <input
                    v-model="searchQuery"
                    type="text"
                    placeholder="Zoek tutorials..."
                    class="w-full pl-20 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 text-sm"
                  />
                  <button
                    v-if="searchQuery"
                    @click="searchQuery = ''"
                    class="absolute inset-y-0 right-0 pr-3 flex items-center"
                  >
                    <svg class="w-8 h-8 text-gray-400 hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                  </button>
                </div>
              </div>

              <!-- Category Filter -->
              <div class="flex flex-wrap gap-1 md:gap-2 overflow-x-auto pb-2">
                <button
                  @click="selectedCategory = 'all'"
                  :class="[
                    'px-3 py-1 rounded-full text-xs font-medium transition-colors',
                    selectedCategory === 'all'
                      ? 'bg-red-600 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200',
                  ]"
                >
                  Alle ({{ tutorials.length }})
                </button>
                <button
                  v-for="category in categories"
                  :key="category.name"
                  @click="selectedCategory = category.name"
                  :class="[
                    'px-3 py-1 rounded-full text-xs font-medium transition-colors',
                    selectedCategory === category.name
                      ? 'bg-red-600 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200',
                  ]"
                >
                  {{ category.name }} ({{ category.count }})
                </button>
              </div>

              <!-- Video List -->
              <div class="max-h-[400px] md:max-h-[500px] overflow-y-auto">
            <div class="divide-y divide-gray-100">
              <div
                v-for="(video, index) in filteredTutorials"
                :key="video.id"
                @click="selectVideoFromFiltered(index)"
                :class="[
                  'p-3 md:p-4 cursor-pointer transition-colors hover:bg-gray-50',
                  currentVideo && currentVideo.id === video.id
                    ? 'bg-red-50 border-l-4 border-red-600'
                    : '',
                ]"
              >
                <div class="flex items-start space-x-3">
                  <!-- Video Thumbnail Placeholder -->
                  <div
                    class="w-12 h-9 md:w-16 md:h-12 bg-gray-200 rounded-lg flex items-center justify-center flex-shrink-0"
                  >
                    <svg
                      class="w-6 h-6 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1m4 0h1m-6 4h8m-7-9h6a2 2 0 012 2v8a2 2 0 01-2 2H8a2 2 0 01-2-2V7a2 2 0 012-2z"
                      ></path>
                    </svg>
                  </div>

                  <!-- Video Info -->
                  <div class="flex-1 min-w-0 overflow-hidden">
                    <h4
                      :class="[
                        'text-sm font-medium line-clamp-2 break-words',
                        currentVideo && currentVideo.id === video.id
                          ? 'text-red-900'
                          : 'text-gray-900',
                      ]"
                    >
                      {{ video.title }}
                    </h4>
                  </div>

                  <!-- Playing Indicator -->
                  <div
                    v-if="currentVideo && currentVideo.id === video.id"
                    class="flex-shrink-0"
                  >
                    <div
                      class="w-8 h-8 bg-red-600 rounded-full flex items-center justify-center"
                    >
                      <svg
                        class="w-8 h-8 text-white"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>

                <!-- No Results Message -->
                <div v-if="filteredTutorials.length === 0" class="p-8 text-center text-gray-500">
                  <svg class="w-12 h-12 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                  </svg>
                  <p class="text-lg font-medium mb-2">Geen tutorials gevonden</p>
                  <p class="text-sm">
                    <span v-if="searchQuery">Probeer te zoeken met andere zoekwoorden</span>
                    <span v-else>Geen tutorials beschikbaar in deze categorie</span>
                  </p>
                  <button
                    v-if="searchQuery || selectedCategory !== 'all'"
                    @click="searchQuery = ''; selectedCategory = 'all'"
                    class="mt-4 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm"
                  >
                    Filters wissen
                  </button>
                </div>
              </div>
            </div>

            <!-- Instructions Tab -->
            <div v-else-if="activeTab === 'instructions'" class="p-4 md:p-6">
              <div class="flex items-center space-x-3 mb-4">
                <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                  <svg class="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
                  </svg>
                </div>
                <div>
                  <h3 class="font-semibold text-gray-900">Tutorial Instructies</h3>
                  <p class="text-sm text-gray-600">Stap-voor-stap gids</p>
                </div>
              </div>

              <!-- Tutorial Content -->
              <div class="max-h-[500px] overflow-y-auto">
                <!-- Loading state -->
                <div v-if="loadingContent" class="flex items-center justify-center py-8">
                  <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-red-600"></div>
                  <span class="ml-3 text-gray-600">Tutorial inhoud laden...</span>
                </div>

                <!-- Error state -->
                <div v-else-if="contentError" class="p-4 bg-red-50 border border-red-200 rounded-lg">
                  <div class="flex items-start space-x-3">
                    <svg class="w-5 h-5 text-red-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    <div>
                      <p class="text-red-800 text-sm font-medium">Kan tutorial inhoud niet laden</p>
                      <p class="text-red-700 text-sm mt-1">{{ contentError }}</p>
                      <button
                        @click="loadTutorialContent(currentVideo.postId)"
                        class="mt-2 text-sm text-red-600 hover:text-red-800 underline"
                      >
                        Opnieuw proberen
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Tutorial content -->
                <div v-else-if="currentTutorialContent" class="prose prose-sm max-w-none">
                  <div v-html="currentTutorialContent.content" class="tutorial-content"></div>
                </div>

                <!-- No Content Available Message -->
                <div v-else-if="currentVideo && currentVideo.postId" class="text-center py-8">
                  <svg class="w-12 h-12 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                  </svg>
                  <p class="text-gray-600 mb-2">Geen gedetailleerde tutorialgids beschikbaar</p>
                  <p class="text-sm text-gray-500">Bekijk de video voor instructies</p>
                </div>

                <!-- Default message for videos without postId -->
                <div v-else class="text-center py-8">
                  <svg class="w-12 h-12 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1m4 0h1m-6 4h8m-7-9h6a2 2 0 012 2v8a2 2 0 01-2 2H8a2 2 0 01-2-2V7a2 2 0 012-2z"></path>
                  </svg>
                  <p class="text-gray-600 mb-2">Alleen Video Tutorial</p>
                  <p class="text-sm text-gray-500">Deze tutorial is beschikbaar in videoformaat hierboven</p>
                </div>
              </div>
            </div>
          </div>

          <!-- STACKED MODE: Show both playlist and instructions stacked -->
          <div v-else-if="layoutMode === 'stacked'" class="space-y-4">
            <!-- Compact Playlist Section -->
            <div class="bg-white rounded-xl shadow-sm">
              <div class="p-3 border-b border-gray-100">
                <div class="flex items-center space-x-2">
                  <div class="w-6 h-6 bg-red-100 rounded-lg flex items-center justify-center">
                    <svg class="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                    </svg>
                  </div>
                  <h3 class="text-sm font-semibold text-gray-900">Playlist</h3>
                  <span class="text-xs text-gray-500">({{ tutorials.length }} videos)</span>
                </div>
              </div>

              <!-- Compact Search Bar -->
              <div class="p-3 border-b border-gray-100">
                <div class="relative">
                  <div class="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
                    <svg class="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                    </svg>
                  </div>
                  <input
                    v-model="searchQuery"
                    type="text"
                    placeholder="Zoeken..."
                    class="w-full pl-20 pr-3 py-1.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 text-xs"
                  />
                </div>
              </div>

              <!-- Compact Category Filter -->
              <div class="px-3 py-2 border-b border-gray-100">
                <div class="flex flex-wrap gap-1 overflow-x-auto">
                  <button
                    @click="selectedCategory = 'all'"
                    :class="[
                      'px-2 py-1 rounded-full text-xs font-medium transition-colors flex-shrink-0',
                      selectedCategory === 'all'
                        ? 'bg-red-600 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200',
                    ]"
                  >
                    Alle
                  </button>
                  <button
                    v-for="category in categories"
                    :key="category.name"
                    @click="selectedCategory = category.name"
                    :class="[
                      'px-2 py-1 rounded-full text-xs font-medium transition-colors flex-shrink-0',
                      selectedCategory === category.name
                        ? 'bg-red-600 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200',
                    ]"
                  >
                    {{ category.name }}
                  </button>
                </div>
              </div>

              <!-- Compact Video List -->
              <div class="max-h-[200px] overflow-y-auto pt-3">
                <div class="divide-y divide-gray-100">
                  <div
                    v-for="(video, index) in filteredTutorials"
                    :key="video.id"
                    @click="selectVideoFromFiltered(index)"
                    :class="[
                      'p-2 cursor-pointer transition-colors hover:bg-gray-50 flex items-center space-x-2 column',
                      currentVideo && currentVideo.id === video.id
                        ? 'bg-red-50 border-l-4 border-red-600'
                        : '',
                    ]"
                  >
                    <!-- Video Thumbnail Placeholder -->
                    <div class="w-8 h-6 bg-gray-200 rounded flex items-center justify-center flex-shrink-0">
                      <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1m4 0h1m-6 4h8m-7-9h6a2 2 0 012 2v8a2 2 0 01-2 2H8a2 2 0 01-2-2V7a2 2 0 012-2z"></path>
                      </svg>
                    </div>

                    <!-- Video Info -->
                    <div class="flex-1 min-w-0">
                      <h4 class="text-xs font-medium line-clamp-2 text-gray-900">
                        {{ video.title }}
                      </h4>
                    </div>

                    <!-- Playing Indicator -->
                    <div v-if="currentVideo && currentVideo.id === video.id" class="flex-shrink-0">
                      <div class="w-5 h-5 bg-red-600 rounded-full flex items-center justify-center">
                        <svg class="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- No Results Message -->
                <div v-if="filteredTutorials.length === 0" class="p-4 text-center text-gray-500">
                  <p class="text-xs">Geen tutorials gevonden</p>
                </div>
              </div>
            </div>

            <!-- Instructions Section (Larger) -->
            <div class="bg-white rounded-xl shadow-sm">
              <div class="p-3 border-b border-gray-100">
                <div class="flex items-center space-x-2">
                  <div class="w-6 h-6 bg-blue-100 rounded-lg flex items-center justify-center">
                    <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
                    </svg>
                  </div>
                  <span v-if="currentVideo" class="text-xs text-gray-500">{{ currentVideo.title }}</span>
                </div>
              </div>

              <!-- Tutorial Content -->
              <div class="p-3 max-h-[450px] overflow-y-auto">
                <!-- Loading state -->
                <div v-if="loadingContent" class="flex items-center justify-center py-8">
                  <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-red-600"></div>
                  <span class="ml-2 text-gray-600 text-sm">Laden...</span>
                </div>

                <!-- Error state -->
                <div v-else-if="contentError" class="p-3 bg-red-50 border border-red-200 rounded-lg">
                  <div class="flex items-start space-x-2">
                    <svg class="w-8 h-8 text-red-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    <div>
                      <p class="text-red-800 text-xs font-medium">Kan inhoud niet laden</p>
                      <button
                        @click="loadTutorialContent(currentVideo.postId)"
                        class="mt-1 text-xs text-red-600 hover:text-red-800 underline"
                      >
                        Opnieuw proberen
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Tutorial content -->
                <div v-else-if="currentTutorialContent" class="prose prose-sm max-w-none">
                  <div v-html="currentTutorialContent.content" class="tutorial-content"></div>
                </div>

                <!-- No Content Available Message -->
                <div v-else-if="currentVideo && currentVideo.postId" class="text-center py-6">
                  <svg class="w-8 h-8 mx-auto mb-2 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                  </svg>
                  <p class="text-gray-600 text-xs">Geen gids beschikbaar</p>
                </div>

                <!-- Default message for videos without postId -->
                <div v-else class="text-center py-6">
                  <svg class="w-8 h-8 mx-auto mb-2 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1m4 0h1m-6 4h8m-7-9h6a2 2 0 012 2v8a2 2 0 01-2 2H8a2 2 0 01-2-2V7a2 2 0 012-2z"></path>
                  </svg>
                  <p class="text-gray-600 text-xs">Alleen Video Tutorial</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WordPressService from "@/services/WordPressService";
import tutorialsData from "@/data/tutorials.json";

export default {
  name: "PublicTutorials",
  data() {
    return {
      currentIndex: 0,
      selectedCategory: "all",
      searchQuery: "",
      tutorialContents: {},
      loadingContent: false,
      contentError: null,
      activeTab: "playlist",
      layoutMode: this.getStoredLayoutMode(),
      tutorials: tutorialsData,
    };
  },
  computed: {
    currentVideo() {
      return this.tutorials[this.currentIndex] || null;
    },
    currentTutorialContent() {
      if (!this.currentVideo || !this.currentVideo.postId) {
        return null;
      }
      return this.tutorialContents[this.currentVideo.postId] || null;
    },
    categories() {
      const categoryCount = {};
      this.tutorials.forEach((tutorial) => {
        categoryCount[tutorial.category] =
          (categoryCount[tutorial.category] || 0) + 1;
      });

      return Object.keys(categoryCount)
        .map((category) => ({
          name: category,
          count: categoryCount[category],
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    filteredTutorials() {
      let filtered = this.tutorials;

      if (this.selectedCategory !== "all") {
        filtered = filtered.filter(
          (tutorial) => tutorial.category === this.selectedCategory
        );
      }

      if (this.searchQuery.trim()) {
        const query = this.searchQuery.toLowerCase().trim();
        filtered = filtered.filter(
          (tutorial) =>
            tutorial.title.toLowerCase().includes(query) ||
            tutorial.category.toLowerCase().includes(query) ||
            tutorial.id.toLowerCase().includes(query)
        );
      }

      return filtered;
    },
  },
  methods: {
    getStoredLayoutMode() {
      try {
        const stored = localStorage.getItem('tutorials-layout-mode');
        return stored && ['tabs', 'stacked'].includes(stored) ? stored : 'tabs';
      } catch (error) {
        console.warn('Failed to read layout preference from localStorage:', error);
        return 'tabs';
      }
    },

    saveLayoutMode(mode) {
      try {
        localStorage.setItem('tutorials-layout-mode', mode);
      } catch (error) {
        console.warn('Failed to save layout preference to localStorage:', error);
      }
    },

    toggleLayoutMode() {
      const newMode = this.layoutMode === 'tabs' ? 'stacked' : 'tabs';
      this.layoutMode = newMode;
      this.saveLayoutMode(newMode);
    },

    getTutorialIdFromUrl() {
      return this.$route.query.tutorial || null;
    },

    updateUrlWithTutorial(tutorialId) {
      if (tutorialId && tutorialId !== this.$route.query.tutorial) {
        this.$router.replace({
          query: {
            ...this.$route.query,
            tutorial: tutorialId
          }
        });
      }
    },

    initializeFromUrl() {
      const tutorialId = this.getTutorialIdFromUrl();

      if (tutorialId) {
        const tutorialIndex = this.tutorials.findIndex(t => t.id === tutorialId);
        if (tutorialIndex !== -1) {
          this.currentIndex = tutorialIndex;
          this.loadTutorialContentIfNeeded();
          return;
        }
      }

      this.currentIndex = 0;
      this.updateUrlWithTutorial(this.tutorials[0]?.id);
      this.loadTutorialContentIfNeeded();
    },

    selectVideo(index) {
      this.currentIndex = index;
      const selectedTutorial = this.tutorials[index];
      if (selectedTutorial) {
        this.updateUrlWithTutorial(selectedTutorial.id);
      }
      this.loadTutorialContentIfNeeded();
    },
    async loadTutorialContentIfNeeded() {
      const video = this.currentVideo;
      if (video && video.postId && !this.tutorialContents[video.postId]) {
        await this.loadTutorialContent(video.postId);
      }
    },
    async loadTutorialContent(postId) {
      if (!postId) return;

      this.loadingContent = true;
      this.contentError = null;

      try {
        const post = await WordPressService.getPost(postId);

        this.$set(this.tutorialContents, postId, {
          title: post.title,
          content: WordPressService.formatContent(post.content),
          date: post.date,
          categories: WordPressService.getCategoryNames(post),
          firstCategory: WordPressService.getFirstCategoryName(post)
        });

        const currentVideo = this.tutorials.find(t => t.postId === postId);
        if (currentVideo && this.tutorialContents[postId].firstCategory) {
          currentVideo.category = this.tutorialContents[postId].firstCategory;
        }

        if (this.layoutMode === 'tabs' && this.activeTab === 'playlist') {
          this.activeTab = 'instructions';
        }

      } catch (error) {
        console.error('Failed to load tutorial content:', error);
        this.contentError = 'Unable to load tutorial content. Please try again later.';
      } finally {
        this.loadingContent = false;
      }
    },
    selectVideoFromFiltered(filteredIndex) {
      const selectedVideo = this.filteredTutorials[filteredIndex];
      const originalIndex = this.tutorials.findIndex(
        (tutorial) => tutorial.id === selectedVideo.id
      );
      this.currentIndex = originalIndex;
      if (selectedVideo) {
        this.updateUrlWithTutorial(selectedVideo.id);
      }
      this.loadTutorialContentIfNeeded();
    },
    nextVideo() {
      if (this.currentIndex < this.tutorials.length - 1) {
        this.currentIndex++;
        const selectedTutorial = this.tutorials[this.currentIndex];
        if (selectedTutorial) {
          this.updateUrlWithTutorial(selectedTutorial.id);
        }
        this.loadTutorialContentIfNeeded();
      }
    },
    previousVideo() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        const selectedTutorial = this.tutorials[this.currentIndex];
        if (selectedTutorial) {
          this.updateUrlWithTutorial(selectedTutorial.id);
        }
        this.loadTutorialContentIfNeeded();
      }
    },
    getEmbedUrl(driveUrl) {
      const fileIdMatch = driveUrl.match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
      if (fileIdMatch) {
        const fileId = fileIdMatch[1];
        return `https://drive.google.com/file/d/${fileId}/preview`;
      }
      return driveUrl;
    },
    refreshVideo() {
      const iframe = document.querySelector("iframe");
      if (iframe) {
        const currentSrc = iframe.src;
        iframe.src = "about:blank";
        setTimeout(() => {
          iframe.src = currentSrc;
        }, 100);
      }
    },
  },
  watch: {
    layoutMode(newMode) {
      this.saveLayoutMode(newMode);
    },

    '$route.query.tutorial'(newTutorialId, oldTutorialId) {
      if (newTutorialId !== oldTutorialId) {
        const tutorialIndex = this.tutorials.findIndex(t => t.id === newTutorialId);
        if (tutorialIndex !== -1 && tutorialIndex !== this.currentIndex) {
          this.currentIndex = tutorialIndex;
          this.loadTutorialContentIfNeeded();
        }
      }
    }
  },
  mounted() {
    this.initializeFromUrl();
  },
};
</script>

<style>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.aspect-w-16 {
  position: relative;
  padding-bottom: 56.25%;
  overflow: hidden;
}

.aspect-w-16 iframe {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border: 0;
}

* {
  box-sizing: border-box;
}

.min-h-screen {
  overflow-x: hidden;
}

.tutorial-content .uptodate-blogpost h1 {
  font-size: 2.5rem;
}

.tutorial-content .uptodate-blogpost h2 {
  font-size: 2rem;
}

.tutorial-content .uptodate-blogpost h3 {
  font-size: 1.8rem;
}
</style>
